import { useState } from "react";
import { IconButton, Tooltip, Box } from "@radix-ui/themes";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

export function PredictionInfoTooltip() {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip
      content={
        <Box style={{ textAlign: "center" }}>
          <Box>AI can make mistakes.</Box>
          <Box>Always double-check results.</Box>
        </Box>
      }
      open={isTooltipOpen}
      onOpenChange={setIsTooltipOpen}
    >
      <IconButton
        size="1"
        variant="ghost"
        color="gray"
        onClick={() => setIsTooltipOpen(!isTooltipOpen)}
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}
      >
        <ExclamationTriangleIcon />
      </IconButton>
    </Tooltip>
  );
}
